import { LanguageFlag } from 'components/facets/LanguageFlag'
import { useUser } from 'components/providers/UserProvider'
import { currencySymbol } from 'lib/utils'
import { CardmarketArticle, flagCode, REPUTATIONS, SellerLevel, SELLER_LEVELS } from 'shared'
import { FIRST_EDITION_ICON, FOIL_ICON, PLAYSET_ICON, SIGNED_ICON } from 'utils/constants'
import { Condition } from './Condition'
import { CustomTooltip } from './CustomTooltip'
// import { AllSellersIcon, PowerSellerSellersIcon, ProfessionalSellersIcon } from './Icons'

export const PriceSuggestArticle = ({ article }: { article: CardmarketArticle }): JSX.Element => {
  const { quantity, isFoil, isPlayset, isFirstEd, isSigned, condition, idLanguage, seller } =
    article

  const { user } = useUser()

  const price = article[user?.currency === 'GBP' ? 'priceGBP' : 'price']

  // const SellerIcon = {
  //   [SellerLevel.Private]: AllSellersIcon,
  //   [SellerLevel.Professional]: ProfessionalSellersIcon,
  //   [SellerLevel.Powerseller]: PowerSellerSellersIcon,
  // }[seller.isCommercial]

  const sellerIcon = () => {
    switch (seller.isCommercial) {
      case SellerLevel.Private:
        return <i className="fa-solid fa-user-group"></i>

      case SellerLevel.Professional:
        return <i className="fa-solid fa-briefcase"></i>

      case SellerLevel.Powerseller:
        return <i className="fa-solid fa-apartment"></i>
      default:
        return <i className="fa-solid fa-user-group"></i>
    }
  }

  return (
    <div>
      <div className="d-flex align-items-center pb-1">
        {` ${seller.username}(${seller.sellCount}) | ${seller.country} | 
        `}
        <CustomTooltip title={`${SELLER_LEVELS[Number(seller.isCommercial)]}`}>
          <div className="mx-1">{sellerIcon()}</div>
        </CustomTooltip>
        {`
      | ${REPUTATIONS[Number(seller.reputation)]} `}
      </div>
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          {quantity}x <Condition id="PriceSuggestArticle-condition" value={condition} />{' '}
          <LanguageFlag
            style={{ padding: '0px 5px' }}
            height="12"
            code={flagCode(idLanguage) || 'gg'}
          />{' '}
          {isFoil && <img alt="foil" height="18px" src={FOIL_ICON} />}{' '}
          {isPlayset && <img alt="playset" height="18px" src={PLAYSET_ICON} />}
          {isFirstEd && <img alt="playset" height="18px" src={FIRST_EDITION_ICON} />}
          {isSigned && <img alt="playset" height="18px" src={SIGNED_ICON} />}
        </div>
        <b>
          {price}
          {currencySymbol(user?.currency)}
        </b>
      </div>
    </div>
  )
}
